import { combineReducers } from 'redux'
import entitiesReducer from './entitiesReducer'
import queryReducer from './queryReducer'

export default combineReducers({
  entities: entitiesReducer,
  queries: queryReducer
})
